import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import DynamicField from "./component/TextFiled";

const buildValidationSchema = (formFields) => {
  const shape = {};
  formFields?.forEach((field) => {
    let validator = Yup.string();

    // Common required check
    if (field.required) {
      validator = validator.required(`${field.fieldName} is required`);
    }

    // Mobile number validation (exactly 10 digits)
    if (field.fieldId === "mobileNumber") {
      validator = Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required");
    }

    // Email validation
    if (field.fieldId === "email") {
      validator = Yup.string()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email format"
        )
        .required("Email is required");
    }

    shape[field.fieldId] = validator;
  });

  return Yup.object().shape(shape);
};

const MyForm = ({ formData, onSubmit, initialValues = {} }) => {
  const formInitialValues = formData?.formFields?.reduce((acc, field) => {
    acc[field.fieldId] = initialValues[field.fieldId] || "";
    return acc;
  }, {});

  const validationSchema = buildValidationSchema(formData?.formFields);

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {() => (
        <Form id="dynamic-form">
          {formData?.formFields.map((field) => (
            <DynamicField
              key={field.fieldId}
              name={field.fieldId}
              label={field.fieldName}
              type={field.type}
              options={field.option || []}
              placeholder={field.placeholder}
              required={field.required}
            />
          ))}
        </Form>
      )}
    </Formik>
  );
};

export default MyForm;
